import { render } from "./CrmBottomNavigation.vue?vue&type=template&id=67165ac2&scoped=true"
import script from "./CrmBottomNavigation.vue?vue&type=script&lang=js"
export * from "./CrmBottomNavigation.vue?vue&type=script&lang=js"

import "./CrmBottomNavigation.vue?vue&type=style&index=0&id=67165ac2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67165ac2"]])

export default __exports__